import axiosClient from "./axiosClient";

/**
 * Create Razorpay order
 */
export const createOrder = async (token, payload) => {
  try {
    const res = await axiosClient.post(
      "/payments/create_order.php",
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    console.error("Create Order Error:", err);
    return { status: "error", message: "Unable to create order" };
  }
};

/**
 * Verify Razorpay payment
 */
export const verifyPayment = async (token, payload) => {
  try {
    const res = await axiosClient.post(
      "/payments/verify_payment.php",
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    console.error("Verify Payment Error:", err);
    return { status: "error", message: "Unable to verify payment" };
  }
};

// src/api/paymentService.js

// export const validateWaiverCode = async (token, payload) => {
//   try {
//     const response = await fetch(
//       `${process.env.REACT_APP_API_URL}/validate-waiver-code`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`
//         },
//         body: JSON.stringify(payload)
//       }
//     );

//     return await response.json();
//   } catch (error) {
//     console.error("Waiver validation error:", error);
//     return { status: "failure" };
//   }
// };

/**
 * Validate Waiver/Discount Code
 */
export const validateWaiverCode = async (token, payload) => {
  try {
    const res = await axiosClient.post(
      "/payments/waiver_code.php",
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    console.error("Waiver Validation Error:", err);
    return { 
      status: "error", 
      message: "Unable to validate waiver code" 
    };
  }
};